import { schema as schemas } from 'normalizr'
import { CallApi } from '@signavio/kraken'

import { Task } from '../../../types'

import { GROUP, USER } from '../users'

export const collection = 'tasks'

export const schema = new schemas.Entity(collection, undefined, {
  processStrategy: (task: Task) => ({
    ...task,

    assignee: task.assignee || null,
    assigneeId: task.assigneeId || null,
    assigneeGroup: task.assigneeGroup || null,
    assigneeGroupId: task.assigneeGroupId || null,
  }),
})

schema.define({
  parent: schema,
  subtasks: [schema],
  assigneeGroup: GROUP.schema,
  assignee: USER.schema,
})

export const create =
  (callApi: CallApi, apiBase: string) => (_: unknown, task: Task) =>
    callApi(`${apiBase}/tasks`, schema, { method: 'POST', body: task })

export const fetch =
  (callApi: CallApi, apiBase: string) =>
  ({ id }: { id: string }) =>
    callApi(`${apiBase}/tasks/${id}`, schema)

export const update =
  (callApi: CallApi, apiBase: string) =>
  ({ id }: { id: string }, task: Task) =>
    callApi(`${apiBase}/tasks/${id}`, schema, { method: 'PUT', body: task })
